import { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import gt7Logo from '../../assets/images/gt7-logo.png'
import logo from '../../assets/images/logo.png'
import * as S from './styled'

export default function Footer (): ReactElement {
  return <S.Container>
    <S.Top>
      <figure>
        <img src={logo} alt="" />
      </figure>

      <S.LinksContainer>
        <Link to="https://www.cartaodetodos.com.br/ajuda/" target="_blank" rel="noreferrer">
          Preciso de ajuda
        </Link>

        <Link to="https://www.cartaodetodos.com.br/politica-de-privacidade/" target="_blank" rel="noreferrer">
          Política de Privacidade
        </Link>

        <Link to="/termos-de-adesao">
          Termos de Adesão
        </Link>
      </S.LinksContainer>
    </S.Top>

    <S.Bottom>
      <span>TODOS Empreendimentos LTDA - CNPJ: 04.644.515/0001-85</span>

      <figure>
        <img src={gt7Logo} alt="" />
      </figure>
    </S.Bottom>
  </S.Container>
}
